import React, { useState } from 'react';
import './App.css';
import Menu from './components/Menu';
import { Container, Row, Col, Navbar, NavbarToggler, NavbarBrand, Alert } from 'reactstrap';

function Eventos() {

    const [menu, setMenu] = useState(false);
    const toggleMenu = () => { setMenu(!menu); };

    return (
        <div id="wrapper" className={`d-flex ${menu ? 'toggled' : ''}`}>
            <Menu />
            <div id="page-content-wrapper">
                <Navbar className="bg-azul" dark>
                    <NavbarToggler onClick={toggleMenu} className="mr-2 border-0" />
                    <NavbarBrand className='mr-auto'>Eventos</NavbarBrand>
                </Navbar>
                <Container>
                    <Row>
                        <Col className="mt-3">
                            <Alert color="danger">
                                Nenhum evento disponível no momento.
                            </Alert>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
}

export default Eventos;
